import { jsxs, jsx } from "react/jsx-runtime";
import { Logo } from "../../chunks/logo.js";
import { useMilestonesTimer, BaseProgressBar, TickerWrapper } from "../../chunks/ticker-wrapper.js";
import { ProgressMilestones } from "../../chunks/progress-milestones.js";
import { Color } from "../../common/enums/colors.js";
import { CCAMFlag } from "../../chunks/ccam-flag.js";
import { getCustomLogoConfigFromURL } from "../../chunks/logo.config.js";
import { getProgressBarConfigFromURL } from "../../chunks/progress-bar.helpers.js";
import './max.progressBar.css';const MaxProgressBar = ({
  goalAmount = 0,
  currentAmount = 0,
  backgroundColor = Color.DEFAULT_RED,
  textColor = Color.LIGHT_AQUA,
  milestones = [],
  donations = [],
  rewards = [],
  targets = [],
  showScroller = false,
  showDonors = false,
  showRewards = false,
  showChallenges = false,
  scrollerPosition = "bottom",
  demoShowMilestones = false,
  ccamMode = false,
  campaignName,
  scrollerSpeed = 0.7,
  className,
  customLogoURL,
  logoAnimationEnabled = false
}) => {
  const maxOverlayRightStyle = { height: `${showScroller ? "" : "60px"}` };
  const showMilestones = useMilestonesTimer({
    currentAmount,
    goalAmount,
    initialState: demoShowMilestones
  });
  const scrollerBlock = /* @__PURE__ */ jsx(
    TickerWrapper,
    {
      campaignName,
      className: `ticker-${scrollerPosition}`,
      donations,
      rewards,
      scrollerSpeed,
      showChallenges,
      showDonors,
      showRewards,
      showScroller,
      targets,
      textColor
    }
  );
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: `max-overlay ${className ? `cf ${className}` : "cf"} ${showScroller ? "scroller" : "no-scroller"}`,
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: !showScroller ? "max-overlay__left small" : "max-overlay__left",
              children: /* @__PURE__ */ jsx(
                Logo,
                {
                  customLogoSmallHeight: 50,
                  customLogoSmallWidth: 50,
                  customLogoURL,
                  isSmall: !showScroller,
                  logoAnimationEnabled: !!customLogoURL || logoAnimationEnabled
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "max-overlay__right", style: maxOverlayRightStyle, children: [
            scrollerPosition === "top" && showScroller ? scrollerBlock : null,
            /* @__PURE__ */ jsx(
              BaseProgressBar,
              {
                backgroundColor,
                ccamMode,
                currentAmount,
                goalAmount,
                height: 60,
                showMilestones,
                width: 1750,
                children: /* @__PURE__ */ jsx(
                  ProgressMilestones,
                  {
                    currentAmount,
                    goalAmount,
                    milestones,
                    showMilestones
                  }
                )
              }
            ),
            scrollerPosition === "bottom" && showScroller ? scrollerBlock : null
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(CCAMFlag, { show: ccamMode })
  ] });
};
const MaxProgressBarTextColors = [
  Color.LIGHT_AQUA,
  Color.LIGHT_GREEN,
  Color.DARK_GREEN,
  Color.LIGHT_YELLOW,
  Color.DARK_YELLOW,
  Color.MEDIUM_GREY
];
function toMaxProgressBarTextColor(color) {
  if (!color || color.length === 0) {
    return Color.MEDIUM_GREY;
  }
  return MaxProgressBarTextColors.find((c) => c === color) ?? Color.MEDIUM_GREY;
}
function getMaxConfigFromURL(url) {
  const config = new URLSearchParams(url.search);
  const textColor = toMaxProgressBarTextColor(config.get("textColor"));
  const scrollerPosition = (config.get("scrollerPosition") ?? "bottom") === "top" ? "top" : "bottom";
  return {
    textColor,
    scrollerPosition,
    ...getProgressBarConfigFromURL(url),
    ...getCustomLogoConfigFromURL(url)
  };
}
export {
  MaxProgressBar,
  MaxProgressBarTextColors,
  getMaxConfigFromURL,
  toMaxProgressBarTextColor
};
//# sourceMappingURL=max.progressBar.js.map
